import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = '[ INDICES ]';

const Actions = {
	fetchGlobalIndices: `${MODULE_PREFIX} fetchGlobalIndices`,
	setGlobalIndices: `${MODULE_PREFIX} setGlobalIndices`,
	// INDIAN
	fetchIndianIndices: `${MODULE_PREFIX} fetchIndianIndices`,
	setIndianIndices: `${MODULE_PREFIX} setIndianIndices`,
	setSelectedIndicesTabData: `${MODULE_PREFIX} setSelectedIndicesTabData`,
};

export const fetchGlobalIndices = createAction(Actions.fetchGlobalIndices);
export const setGlobalIndices = createAction(Actions.setGlobalIndices);

export const fetchIndianIndices = createAction(Actions.fetchIndianIndices);
export const setIndianIndices = createAction(Actions.setIndianIndices);
export const setSelectedIndicesTabData = createAction(Actions.setSelectedIndicesTabData);

export const getGlobalIndices = (state = {}) => {
	return get(state, 'indices.globalIndices', {});
};

export const getIndianIndies = (state = {}) => {
	return get(state, 'indices.indianIndices', {});
};

export const getSelectedIndicesTabData = (state = {}) => {
	return get(state, 'indices.selectedIndicesTabData', {});
};

const initialState = {
	globalIndices: {},
	indianIndices: {},
	selectedIndicesTabData: {},
};

export default createReducer(initialState, (builder) => {
	builder.addCase(setGlobalIndices, (state, action) => {
		state.globalIndices = action.payload;
	});
	builder.addCase(setIndianIndices, (state, action) => {
		state.indianIndices = action.payload;
	});
	builder.addCase(setSelectedIndicesTabData, (state, action) => {
		state.selectedIndicesTabData = action.payload;
	});
});
